export type RuntimeEnv = Partial<{
  VITE_API_BASE_URL: string;
}>;

declare global {
  interface Window {
    __ENV__?: RuntimeEnv;
  }
}

function readRuntimeEnv(): RuntimeEnv {
  if (typeof window === 'undefined') return {};
  const env = window.__ENV__;
  if (!env || typeof env !== 'object') return {};
  return env;
}

export function getApiBaseUrl(): string {
  // 1. Проверяем runtime env (из window.__ENV__, устанавливается через /env.js)
  const runtime = readRuntimeEnv();
  const fromRuntime = runtime.VITE_API_BASE_URL;
  if (typeof fromRuntime === 'string' && fromRuntime.trim().length > 0) {
    return fromRuntime.trim();
  }

  // 2. Проверяем build-time env (из .env файлов, доступны через import.meta.env)
  const fromBuild = import.meta.env.VITE_API_BASE_URL;
  if (typeof fromBuild === 'string' && fromBuild.trim().length > 0) {
    return fromBuild.trim();
  }

  // 3. Fallback для локальной разработки
  return 'http://localhost:4000';
}

